import PointsHistorySortMenu from './PointsHistorySortMenu'

export default PointsHistorySortMenu
